<template>
    <div class="lib-faq">
        <h2>Frequently Asked Questions</h2>
        <div class="categories">
            <button
                v-for="(category, categoryIndex) in faq"
                :class="{active: categoryIndex === openCategoryIndex}"
                @click="categoryClicked(categoryIndex)"
            >{{ category.name }}</button>
        </div>
        <div class="category" v-for="(category, categoryIndex) in faq" v-if="categoryIndex === openCategoryIndex">
            <div class="question-answer" v-for="(question, index) in category.questions">
                <div class="question" @click="questionClicked(index)">
                    <h3>{{ question.question }}</h3>
                    <button>
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <div class="answer" v-if="openQuestionIndex === index">
                    <p v-for="paragraph in question.answer" v-html="paragraph"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {marketingFaq} from "./marketingFaq";

export default {
    name: "LibFaq",
    props: ['default'],
    data() {
        return {
            faq: marketingFaq,
            openCategoryIndex: this.default,
            openQuestionIndex: null,
        }
    },
    methods: {
        categoryClicked(category) {
            this.openQuestionIndex = null;
            this.openCategoryIndex = category;
        },
        questionClicked(index) {
            if (this.openQuestionIndex !== index) {
                this.openQuestionIndex = index;
            } else {
                this.openQuestionIndex = null;
            }
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../../src/scss/prelude";

.lib-faq {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
        text-align: center;
    }

    h3 {
        font-weight: 600;
        font-size: 20px;
    }

    .categories {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
        margin-top: 30px;
    }

    .categories button {
        box-sizing: content-box;
        color: $blue;
        border: 2px solid $blue;
        border-radius: 6px;
        padding: 15px 20px;
        font-weight: bold;

        &.active {
            background-color: $blue;
            color: $white;
        }

        &:not(.active):hover {
            cursor: pointer;
            border: 3px solid $bluehover;
            color: $bluehover;
            margin: -1px;
        }
    }

    .category {
        margin-top: 55px;
        max-width: 940px;
        width: 100%;
    }

    .question {
        padding: 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        color: $navy;

        button {
            font-size: 20px;
            color: $blue;
        }

        &:hover, &:focus {
            color: $navyhover;

            button {
                color: $bluehover;
            }
        }
    }

    .answer {
        padding: 0 20px;
        margin-bottom: 20px;
        line-height: 26px;

        p + p {
            margin-top: 20px;
        }
    }

    .question-answer {
        border-bottom: 1px solid var(--lib-border-color);
    }
}
</style>